module.exports = __webpack_public_path__ + "static/alumni-impact-report_2009-2021-9186b2b4761016a0a654ba2bcae7b570.pdf";